import Company from "./Company.js";

let instance;

/**
 * Null object pattern.
 */
export default class NullCompany extends Company {
	getId() {
		return "no-company";
	}

	isNullCompany() {
		return true;
	}

	getBusinessIdentityCode() {
		return null;
	}

	getQuickbooksIntegrationAttachmentImportOption() {
		return true;
	}

	getTripletexIntegrationInvoiceImportOption() {
		return true;
	}

	static instance() {
		instance ||= new NullCompany();

		return instance;
	}
}
